<template>
	<a-config-provider :locale="locale">
		<router-view :key="$route.fullPath"/>
	</a-config-provider>
</template>

<script setup name="App">
	import i18n from '@/locales'
	import { useUserStore, useImInfoStore } from '@/store'
	import { mountAllEMListener } from '@/IM/listener'
	import motorApi from '@/api/user/motorApi'

	// 语言设置
    const locale = i18n.global.messages[i18n.global.locale].lang
	// 用户信息Store
	const userStore = useUserStore()
	// 获取登录用户信息
	let token = sessionStorage.getItem('TOKEN')
	if(token) {
		userStore.getUserInfo()
	}

	// 环信用户IM信息
	const imInfoStore = useImInfoStore()

	// 获取字典
	userStore.getDict()

	// 挂载环信IM相关监听回调
	mountAllEMListener()
	
	//监听赣职网用户登录信息
    watch(
        () => userStore.userInfo,
        (newVal) => {
            newVal.id ? imInfoStore.getImInfo() : imInfoStore.imLogout()
        },
        { immediate: true }
    )
	// 上报用户访问记录
	motorApi.uvAdd({
		device: 'PC'
	})
</script>
